import { Box, Paper, Typography } from "@mui/material";

export default function Client360ChannelFieldGrid({
    rows,
    title,
    subtitle,
}: {
    rows: Array<{ label: string; value: string }>;
    title: string;
    subtitle?: string;
}) {
    return (
        <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{title}</Typography>
            {subtitle ? (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 1.5 }}>
                    {subtitle}
                </Typography>
            ) : null}
            <Box sx={{ display: "grid", gap: 1, gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))" } }}>
                {rows.map((row) => (
                    <Box
                        key={row.label}
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: 2,
                            py: 0.75,
                            borderBottom: "1px solid",
                            borderColor: "divider",
                        }}
                    >
                        <Typography variant="caption" color="text.secondary">{row.label}</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600, textAlign: "right" }}>{row.value}</Typography>
                    </Box>
                ))}
            </Box>
        </Paper>
    );
}
